// extracted by mini-css-extract-plugin
export default {"row":"Row_row__B5X+e","action":"Row_action__3hec8","content":"Row_content__mo4eJ","dotsButton":"Row_dotsButton__ezLcY"};